import type {ReactNode} from 'react';
import Header from 'components/Header';
import PhoneNumbers from 'constants/PhoneNumbers';
import Footer from 'components/Footer';
import Helmet from 'components/Helmet';
import LoadingSpinner from 'components/LoadingSpinner';

interface LayoutProps {
  children: ReactNode;
  title: string;
  loading?: boolean;
  orderNumber?: string;
}

const Layout = ({children, title, loading, orderNumber}: LayoutProps) => {
  return (
    <>
      <Helmet title={title}>
        <meta name="apple-itunes-app" content="app-id=1551189516" />
        <meta name="google-play-app" content="app-id=com.ezcater.delivery" />
        <link rel="apple-touch-icon" href="/static/images/app-icon.png" />
        <link rel="android-touch-icon" href="/static/images/app-icon.png" />
      </Helmet>
      {loading && <LoadingSpinner />}
      {!loading && (
        <>
          <Header orderNumber={orderNumber}>{children}</Header>
          <Footer phone={PhoneNumbers.EZDISPATCH_DIRECT} />
        </>
      )}
    </>
  );
};

export default Layout;
